import styled from 'styled-components';

import { fonts } from '@dreryk/react-components';

const StyledSectionHeader = styled.h3`
   margin: 0 0 15px;
   font-weight: ${fonts.fontWeightBold};
`;

StyledSectionHeader.displayName = 'StyledSectionHeader';

export { StyledSectionHeader };
